import {
   faBars,
   faTimes,
} from '@fortawesome/pro-regular-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CircularProgress, useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import unimedLogo from '../../assets/images/logo-unimed-campinas.svg';
import MenuListButton from '../../components/MenuListButton';
import MenuSubItem from '../../components/MenuSubItem';
import MenuSubList from '../../components/MenuSubList';
import User from '../../components/User';
import './styles.css';
import { getBenef } from '../../Store/storages/BeneficiarioStorage';
import { Beneficiario } from '../../interfaces/entities/Beneficiario';
import Accessibility from '../../components/Accessibility';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';
import { MenuItem } from '../../interfaces/Home/MenuItem';
import ModalFeedBack from '../../components/ModalFeedBack';
import Notification from '../../components/Notification';
import { useNavigate } from 'react-router-dom';
import { useHomeContext } from '../../Store/contexts/HomeContext';

function Menu() {
   const navigate = useNavigate()
   const [open, setOpen] = useState<boolean>(false);
   const [benef, setBenef] = useState<Beneficiario | null>(null);
   const [showErrorModal, setShowErrorModal] = useState<boolean>(false);

   const { contrastMode, contrastStyle, textStyleAccessibility, contrastBorderAccessibility } = useAccessibility();

   const min500px = useMediaQuery('(min-width:500px)')
   const max899px = useMediaQuery('(max-width:899px)');

   const { menu } = useHomeContext();
   
   useEffect(() => {
      if (!benef) {
         const benef = getBenef();
         setBenef(benef);
      }
      if (window.screen.availWidth <= 900) {
         setOpen(false);
      }
   }, [benef])

   const openMenu = () => {
      setOpen(!open)
   }

   const renderMenuItem = (m: MenuItem) => {
      return m.standalone
         ? (
            <MenuListButton
               icon={m.icon}
               to={m.path}
               component={m.component}
               handleMenu={handleMenu}
               restricted={m.restricted}
               external={m.external}>
               {m.title}
            </MenuListButton>
         )
         : (
            <MenuSubList key={m.path} icon={m.icon} to={m.path} name={m.title}>
               {
                  m.children.map(c => (
                     <MenuSubItem
                        to={c.path}
                        component={m.component}
                        handleMenu={handleMenu}
                        restricted={c.restricted}
                        external={c.external}>
                        {c.title}
                     </MenuSubItem>
                  ))
               }
            </MenuSubList>
         )
   }

   const handleMenu = () => {
      window.scrollTo(0, 0)
      setOpen(false)
   }

   return (
      <nav className={`${open && 'mobile-nav'}`} style={{ ...contrastStyle, ...contrastBorderAccessibility }}>
         <div id='nav-header' className='nav-header' style={contrastBorderAccessibility}>
            <div onClick={() => navigate('/home')} className='logo-unimed' tabIndex={0}>
               {contrastMode
                  ? <h1 style={textStyleAccessibility} className='unimed-logo'>Unimed<br />Campinas</h1>
                  : <img src={unimedLogo} width={'162px'} height={'61px'} alt="Voltar para o início" />
               }
            </div>
            <div className="mobile-actions">
               {useMediaQuery('(max-width: 899px)') && <Notification />}
               {useMediaQuery('(max-width: 899px)') && <User beneficiario={benef} />}
               <button className='menu-burguer' onClick={openMenu}>
                  {!open && <FontAwesomeIcon icon={faBars} size="2xl" />}
                  {open && <FontAwesomeIcon icon={faTimes} size="2xl" />}
               </button>
            </div>
         </div>
         <div className='overflow-nav-menu' style={contrastStyle}>
            <div className={`nav-list ${open && 'opened-menu'}`} >
               <ul className='menu'>
                  {menu.length
                     ? menu.map(renderMenuItem)
                     : <CircularProgress className='loading-menu' color="inherit" />}
               </ul>
            </div>
         </div>
         {min500px && max899px &&
            <div className={`accessibility ${!open && 'accessibility-hide'}`}>
               <Accessibility />
            </div>
         }

         <ModalFeedBack
            showModal={showErrorModal}
            handleShowModal={() => setShowErrorModal(false)}
            icon={'error'}
            textButton={''}
            title={'Erro ao carregar informações do usuário.'}
            subTitle={'Tente novamente mais tarde.'}
         />

      </nav>
   )
}

export default Menu